import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/Captcha' /* webpackChunkName: "Captcha" */),
    import('./viewer/Captcha.controller' /* webpackChunkName: "Captcha" */),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('Captcha', UiTypes),
};

export default entry;
